import { render, staticRenderFns } from "./recordCheckPerson.vue?vue&type=template&id=14aea10f"
import script from "./recordCheckPerson.vue?vue&type=script&lang=js"
export * from "./recordCheckPerson.vue?vue&type=script&lang=js"
import style0 from "./recordCheckPerson.vue?vue&type=style&index=0&id=14aea10f&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports